console.log("✅ website.js loaded");

if (window.location.pathname === "/wiki/home") {
  if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
    const observer = new MutationObserver(() => {
      const containers = document.querySelectorAll(".file-preview-container");
      if (containers.length > 0) {
        containers.forEach(el => {
          el.style.pointerEvents = "none";
          el.style.background = "none";
          el.style.boxShadow = "none";
        });
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}
